






























import { Component } from 'vue-property-decorator'
import { coreKaizen } from '@/common/coreKaizen'
import { AxiosResponse } from 'axios'
import { processListModel } from '@/models/processListModel';

@Component
export default class processlist extends coreKaizen {
    logoColibri: NodeRequire = require('@/assets/logoColibri.png')
    procesos: processListModel[] = []
    procesoSeleccionado: number = 0
    isLoading: boolean = false

    mounted() {
        this.showProcessList()
    }

    get processSelected(): boolean {
        return this.procesoSeleccionado !== 0
    }

    get processName(): string {
        let newP = this.procesos.filter(x => x.process === this.procesoSeleccionado);
        return newP && newP.length > 0 ? newP[0].name : ''
    }

    showProcessList() {
        if (this.procesos.length === 0) {
            this.getProcessList()
        }
        this.procesoSeleccionado = 0
    }

    getProcessList() {
        this.isLoading = true
        this.GilgameshApi.get('kanban/processes/1')
            .then(r => r as AxiosResponse<processListModel[]>)
            .then(d => {
                this.procesos = d.data
            })
            .catch(x => console.log('reason: ' + x))
            .finally(() => this.isLoading = false)
    }
}
